import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import DateBox from 'devextreme-react/date-box';
import { injectQuickDatePresets } from '../utils/dateQuickPresets';

const LocalizedDateInput = forwardRef(function LocalizedDateInput({
    value,
    withTime = false,
    onValueChange,
    onBlur,
    onKeyDown,
    placeholder,
    className,
    disabled,
    readOnly,
    id,
    min,
    max,
    'aria-invalid': ariaInvalid,
}, ref) {
    const pickerRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => pickerRef.current?.instance?.focus(),
    }), []);

    return (
        <DateBox
            ref={pickerRef}
            className={className}
            inputAttr={{ id, 'aria-invalid': ariaInvalid }}
            value={value || null}
            type={withTime ? 'datetime' : 'date'}
            displayFormat={withTime ? 'dd-MM-yyyy HH:mm' : 'dd-MM-yyyy'}
            placeholder={placeholder || (withTime ? 'gg-aa-yyyy ss:dd' : 'gg-aa-yyyy')}
            disabled={disabled}
            readOnly={readOnly}
            min={min}
            max={max}
            showClearButton={true}
            useMaskBehavior={true}
            pickerType="calendar"
            width="100%"
            onOpened={(event) => injectQuickDatePresets(event?.component)}
            onValueChanged={(event) => onValueChange?.(event.value || null)}
            onFocusOut={(event) => onBlur?.(event.event)}
            onKeyDown={(event) => onKeyDown?.(event.event)}
        />
    );
});

export default LocalizedDateInput;
